import { AppContext, BookingData, Service, ServiceCategory, ServicePage } from "../../../AppDataProvider/AppDataProvider";
import { getFirstStep, requireBookingDataFields } from "../../../utils";
import { NavButtons, Notification } from "../../../common/components";
import React, { ReactElement, useContext } from "react";
import { ActionType } from "../../../AppDataProvider/actions";
import { marginTop } from "../../../common/styles";
import { PartRequired } from "../../../utils/types";
import { ServiceList } from "./ServiceList/ServiceList";
import { ServicesByCategoryList } from "./ServicesByCategoryList/ServicesByCategoryList";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
type ServiceStepBookingData = PartRequired<BookingData, "organisation">;
type StepContentProps = {
  services: ServicePage;
};
export function StepContent(props: StepContentProps): ReactElement {
  const {
    t
  } = useTranslation();
  const {
    appData,
    appDataDispatch
  } = useContext(AppContext);
  const {
    services: servicePages
  } = props;
  const {
    edges
  } = servicePages;
  const services = edges.map(({
    node
  }) => node);
  const {
    bookingTool
  } = appData;
  requireBookingDataFields<ServiceStepBookingData>(appData.bookingData, ["organisation"]);
  const canGoBack = getFirstStep({
    bookingData: appData.bookingData,
    bookingTool
  }) === "organisations";
  const goBack = () => appDataDispatch({
    type: ActionType.BACK_FROM_SERVICES_STEP
  });
  const uniqueCategories = services.reduce((uniqueCategories: ServiceCategory[], currentService: Service) => uniqueCategories.find(category => category._id === currentService.category._id) ? uniqueCategories : [...uniqueCategories, currentService.category], []);
  const categoryCount = uniqueCategories.length;
  return <>
      {services.length > 0 ? categoryCount > 1 ? <ServicesByCategoryList services={services} /> : <ServiceList services={services} /> : <ErrorNotification variant="warning">
          {t("errors.noServices")}
        </ErrorNotification>}

      {canGoBack && <NavButtons {...{
      hideContinue: true,
      onBack: goBack
    }} />}
    </>;
}
const ErrorNotification = styled(Notification)`
  ${marginTop.m}
`;
export default StepContent;